const path = require('path');

export default function importAll(r) {
	let messages = {};
	r.keys().forEach((key) => {
		const msgKey = path.basename(key, '.json');
		if (msgKey === 'general') {
			messages = Object.assign(messages, r(key));
		} else {
			messages[msgKey] = r(key);
		}
		
	});
	return messages;
};
